export enum ScanType {
  CAMERA = "Camera",
  NFC = "NFC",
  EXTERNAL = "External",
}
